export default __webpack_public_path__ + "static/media/Flag_of_Aragon.svg.58c16fa0.png";